export const EMPLOYER_HOME_HOTJAR_SITE_ID = 3579647;
export const EMPLOYER_COMPLIANCE_HOME_HOTJAR_SITE_ID = 3579648;
export const EMPLOYER_SERVICES_HOTJAR_SITE_ID = 3579650;

export const EMPLOYEE_HOME_HOTJAR_SITE_ID = 3579694;

export const SW_CASES_HOTJAR_SITE_ID = 2787081;
